import React, { FC, useEffect } from 'react';
import useCartModelDisplay from '../../../../../hooks/useCartModelDisplay';
import { useFormContext } from 'react-hook-form';
import ProductImageSelect from '../../../../common/Form/FormFields/ProductImageSelect/ProductImageSelect';
import Product from '../../../../../@types/Product';

interface CartProductBodyColorProps {
  retailConfigurator: boolean,
  fromInventory: boolean
}

const CartProductBodyColor: FC<CartProductBodyColorProps> = ({ retailConfigurator, fromInventory }) => {
  const { watch, setValue } = useFormContext();
  const { chassisType, setBodyColor } = useCartModelDisplay();
  const bodyColor: Product | undefined = watch('bodyColor');

  useEffect(() => {
    const seatFrame = chassisType?.seatFrameOptions?.[0];
    // Set the seat frame
    setValue('seatFrame', seatFrame);
    setBodyColor(bodyColor);
  }, [
    bodyColor,
    chassisType,
    setValue,
    setBodyColor
  ]);

  return (
    <ProductImageSelect
      name="bodyColor"
      label="Body Color"
      disableImageZoom={true}
      displayLabel={false}
      displayPrice={false}
      disabled={fromInventory}
      displayRetailPrice={retailConfigurator}
      productAlignment='left'
      products={chassisType?.bodyColorOptions ?? []} />
  );
}

export default CartProductBodyColor;
